export const formatPrice = (price, currency) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || "USD",
  }).format(Number(price));

export const formatCurrencySymbol = (currency) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: currency || "USD" })
    .formatToParts(0)
    .find((part) => part.type === "currency")?.value || "$";

export const formatWholeCents = (cents, currency) =>
  (cents < 0 ? "-" : "") +
  formatCurrencySymbol(currency) +
  Math.abs(cents / 100).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
